module.exports = __webpack_public_path__ + "media/audio11.5d88f352.wav";